export class SelectionTableFieldParameter {
  options: string[] | undefined;
  items: string[] | undefined;
  multipleOptionsPerItem: boolean | undefined;
}
